import { PathBase } from "@constellation-academy/epic-ui";

export class MessageDispatchEditPath extends PathBase {
	static readonly pathKey = "edit";
}
